module.exports = __webpack_public_path__ + "static/img/lixian.8e42174.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/lixian.png
// module id = uUKa
// module chunks = 24